import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ArticlesForHomepageQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type ArticlesForHomepageQuery = { __typename?: 'Query' } & {
    articles?: Types.Maybe<
        { __typename?: 'Articles' } & Pick<
            Types.Articles,
            'total' | 'skip' | 'limit'
        > & {
                items: Array<
                    Types.Maybe<
                        { __typename?: 'ArticleSummary' } & Pick<
                            Types.ArticleSummary,
                            | 'title'
                            | 'slug'
                            | 'snippet'
                            | 'publicationDateAndTime'
                            | 'id'
                        > & {
                                category: {
                                    __typename?: 'ArticleCategory';
                                } & Pick<
                                    Types.ArticleCategory,
                                    'name' | 'slug'
                                >;
                                heroImage: {
                                    __typename?: 'ContentfulImage';
                                } & Pick<Types.ContentfulImage, 'url'>;
                            }
                    >
                >;
            }
    >;
};

export const ArticlesForHomepageDocument = gql`
    query articlesForHomepage {
        articles(category: "property-news", limit: 4) {
            items {
                title
                slug
                snippet
                publicationDateAndTime
                id
                category {
                    name
                    slug
                }
                heroImage {
                    url
                }
            }
            total
            skip
            limit
        }
    }
`;

/**
 * __useArticlesForHomepageQuery__
 *
 * To run a query within a React component, call `useArticlesForHomepageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesForHomepageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesForHomepageQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlesForHomepageQuery(
    baseOptions?: Apollo.QueryHookOptions<
        ArticlesForHomepageQuery,
        ArticlesForHomepageQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        ArticlesForHomepageQuery,
        ArticlesForHomepageQueryVariables
    >(ArticlesForHomepageDocument, options);
}
export function useArticlesForHomepageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ArticlesForHomepageQuery,
        ArticlesForHomepageQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ArticlesForHomepageQuery,
        ArticlesForHomepageQueryVariables
    >(ArticlesForHomepageDocument, options);
}
export type ArticlesForHomepageQueryHookResult = ReturnType<
    typeof useArticlesForHomepageQuery
>;
export type ArticlesForHomepageLazyQueryHookResult = ReturnType<
    typeof useArticlesForHomepageLazyQuery
>;
export type ArticlesForHomepageQueryResult = Apollo.QueryResult<
    ArticlesForHomepageQuery,
    ArticlesForHomepageQueryVariables
>;
